import React, {PureComponent} from 'react';
import { Button, Modal, ModalBody , ModalHeader , ModalFooter} from 'reactstrap';
import ButtonLoaderAtom from 'atoms/ButtonLoader';
import styles from './styles.module.scss';

class EmployeeDeleteModal extends PureComponent {

  render() {
    const {isOpen, toggle, deleteEmployeeAssignment, isSubmitting,employeeDeleteModal, title, description} = this.props;
    return (
      <Modal isOpen={isOpen}>
        <ModalHeader toggle={()=>toggle(null)}>{title}</ModalHeader>
        <ModalBody>
          <div className={styles.modalBody_font}>{description}</div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            onClick={() => deleteEmployeeAssignment(isOpen)}
          >
          Yes <ButtonLoaderAtom active={isSubmitting} />
          </Button>
          <Button color="secondary" onClick={()=>toggle(null)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );}
  }
  
export default EmployeeDeleteModal;